import { UserSupportTicketCategory } from '@trucksmarter/shared';
import { DallasOptionItem } from '../Dallas/Forms/DallasOptionItem/DallasOptionItem';

const SUPPORT_TICKET_CATEGORIES = [
  UserSupportTicketCategory.LoadSearch,
  UserSupportTicketCategory.BookOrBid,
  UserSupportTicketCategory.BidsAndPastLoads,
  UserSupportTicketCategory.ConnectingBrokerAccount,
  // UserSupportTicketCategory.Factoring,
  // UserSupportTicketCategory.FactoringNewBroker,
  // UserSupportTicketCategory.FactoringSubmittedInvoice,
  // UserSupportTicketCategory.DebitCard,
  // UserSupportTicketCategory.BankTransaction,
  // UserSupportTicketCategory.Fuel,
  UserSupportTicketCategory.EditAccount,
  UserSupportTicketCategory.DeleteAccount,
  UserSupportTicketCategory.CarrierVerification,
  UserSupportTicketCategory.Other,
] as const;

export const SUPPORT_TICKET_CATEGORY_LABEL: Record<
  (typeof SUPPORT_TICKET_CATEGORIES)[number],
  string
> = {
  LoadSearch: 'Searching for loads',
  BookOrBid: 'Booking / bidding on loads',
  BidsAndPastLoads: 'My bids or past loads',
  ConnectingBrokerAccount: 'Connecting load boards',
  // Factoring: 'Factoring a load',
  // FactoringNewBroker: 'Factoring new broker request',
  // FactoringSubmittedInvoice: 'Submitted invoice issue',
  // DebitCard: 'Managing my debit card',
  // BankTransaction: 'Resolving a transaction issue',
  // Fuel: 'Fuel',
  EditAccount: 'Editing my account information',
  DeleteAccount: 'Deleting my account',
  CarrierVerification: 'Verifying my carrier identity',
  Other: 'Other',
};

export const SUPPORT_TICKET_CATEGORY_OPTIONS = SUPPORT_TICKET_CATEGORIES.map(
  (value): DallasOptionItem<UserSupportTicketCategory> => ({
    label: SUPPORT_TICKET_CATEGORY_LABEL[value],
    value,
  }),
);

export enum BrokerSupportTicketSubject {
  AddingLoads = 'Adding Loads',
  EditingAccount = 'Editing Account',
  EditingTMS = 'Editing TMS',
  ChangingPostMethod = 'Changing Post Method',
  Other = 'Other',
}

export const BROKER_SUPPORT_TICKET_SUBJECT_OPTIONS: DallasOptionItem<BrokerSupportTicketSubject>[] =
  [
    {
      value: BrokerSupportTicketSubject.AddingLoads,
      label: 'Add loads via TMS or CSV/Excel',
    },
    {
      value: BrokerSupportTicketSubject.EditingAccount,
      label: 'Edit my account information',
    },
    {
      value: BrokerSupportTicketSubject.EditingTMS,
      label: 'Edit my TMS connection',
    },
    {
      value: BrokerSupportTicketSubject.ChangingPostMethod,
      label: 'Switch load posting method',
    },
    {
      value: BrokerSupportTicketSubject.Other,
      label: 'Other',
    },
  ];
